import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

// A blank screen is undebuggable on a phone: if anything throws before or
// during first paint, show the error instead of nothing.
function showBootError(message: string) {
  const root = document.getElementById("root");
  if (root && root.childElementCount === 0) {
    root.innerHTML = `<div style="padding:24px;font-family:system-ui;color:#e8e2d0;background:#12151c;min-height:100vh">
      <h2 style="margin:0 0 12px">Florin hit a snag while starting</h2>
      <p style="font-size:14px;opacity:.8">Screenshot this and send it to support:</p>
      <pre style="white-space:pre-wrap;font-size:12px;background:#1a1f2a;padding:12px;border-radius:8px">${message
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")}</pre>
      <button style="margin-top:14px;padding:10px 18px;border-radius:10px;border:0;background:#d4af37;font-weight:700"
        onclick="location.reload()">Reload</button>
    </div>`;
  }
}
window.addEventListener("error", (e) => showBootError(String(e.error?.stack ?? e.message)));
window.addEventListener("unhandledrejection", (e) => showBootError(String(e.reason?.stack ?? e.reason)));

try {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} catch (err) {
  showBootError(String(err instanceof Error ? (err.stack ?? err.message) : err));
}

// Service worker: app-shell caching so the installed PWA opens instantly.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
